/** Injected at bundle time from `package.json` (see `scripts/build.mjs`). */
declare const __BA_CLI_VERSION__: string | undefined;

export const CLI_VERSION =
  typeof __BA_CLI_VERSION__ === 'string' && __BA_CLI_VERSION__.length > 0 ? __BA_CLI_VERSION__ : '0.0.0-dev';
